import { Component, OnInit, OnDestroy, HostListener, ViewChild, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, NgForm } from '@angular/forms';
import { AuthenticationService } from '@servicios/authentication.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { ConfigService } from '@servicios/config.service';
import { Subscription } from 'rxjs';


export interface ILogin {
  user: string,
  password: string
}

@Component({
    selector: 'app-loginDialog',
    templateUrl: './loginDialog.component.html',
    styleUrls: ['./loginDialog.component.css'],
    standalone: false
})
export class LoginDialogComponent implements OnInit, OnDestroy {

  constructor(private fb: UntypedFormBuilder,
    private auth: AuthenticationService,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    public dialogRef: DynamicDialogRef,
    public configService: ConfigService,
    private cdr: ChangeDetectorRef
  ) { }

  @ViewChild('documentEditForm', { static: false }) documentEditForm: NgForm;
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      if (this.isLoading || this.form?.invalid) {
        return;
      }
      this.documentEditForm?.ngSubmit.emit();
    }
  }

  public isLoading = false;
  public errorMessage: string = '';
  private passwordSub?: Subscription;
  form: UntypedFormGroup;
  data: { user: string, _id: string, client?: boolean };

  ngOnInit() {
    this.data = this.config.data;
    
    this.form = this.fb.group({
      user: [{ value: this.data.user, disabled: true }, [Validators.required]],
      password: ['', [Validators.required]],
    });

    this.passwordSub = this.form.get('password')?.valueChanges.subscribe((val) => {
      // Solo limpiar el mensaje de error cuando el usuario efectivamente escribe algo nuevo
      if (val && this.errorMessage) {
        this.errorMessage = '';
        this.cdr.markForCheck();
      }
    });
  }

  closeDialog(value: boolean) {
    return this.dialogRef.close(value);
  }

  cerrarSesion() {
    // Llamar logout() desde el click del botón garantiza que estamos dentro
    // de Angular zone, por lo que router.navigate() funciona correctamente.
    this.auth.sesionExpirada = false;
    this.auth.logout();
    this.dialogRef.close(false);
  }

  userLogin(form: ILogin, client = false) {
    if (this.isLoading) {
      return;
    }
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.cdr.markForCheck();

    const loginPromise = client
      ? this.auth.clientLogin(this.data.user, form.password, true)
      : this.auth.userLogin(this.data.user, form.password, true);

    loginPromise
      .then(() => {
        // Close the dialog AFTER the login Promise resolves —
        // never from inside a BehaviorSubject.next() callback, which
        // would cause synchronous re-entrancy and browser freeze.
        this.isLoading = false;
        this.closeDialog(true);
      })
      .catch((err) => {
        this.isLoading = false;
        const msg = err?.error?.message 
          || (typeof err?.error === 'string' ? err.error : null)
          || err?.graphQLErrors?.[0]?.message 
          || err?.message 
          || 'Usuario o contraseña incorrectos';
        this.errorMessage = msg;
        // Se resetea el password sin disparar valueChanges para no borrar el errorMessage
        this.form.get('password')?.setValue('', { emitEvent: false });
        this.form.get('password')?.markAsUntouched();
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy() {
    this.passwordSub?.unsubscribe();
  }

}
